import { Select } from '@chakra-ui/react'
import { useGet } from 'hooks/useHttp'
import Booking from 'models/booking'

export interface BookingSelectProps {
    bookingId: string
    onBooking: (bookingId: string) => void
    date: string
}

export default function BookingSelect({
    bookingId,
    onBooking,
    date
}: BookingSelectProps) {
    const { data } = useGet<Booking[]>(
        `2>/api/bookings?sort=id&types=1,2&date=${date || ''}`,
        []
    )

    const bookingAgencies = data.result
        .filter(booking => booking.agency_id)
        .sort((a, b) => {
            const aName = a.agency?.name || ''
            const bName = b.agency?.name || ''
            if (aName < bName) {
                return -1
            }
            if (aName > bName) {
                return 1
            }
            return 0
        })
    const bookingAgenciesFiltered: Array<Booking & { ids: number[] }> = []
    bookingAgencies.forEach(booking => {
        const bookingAgencyFiltrd = bookingAgenciesFiltered.find(
            _booking =>
                _booking.agency_id === booking.agency_id &&
                _booking.agency_guide_id === booking.agency_guide_id
        )
        if (bookingAgencyFiltrd) {
            bookingAgencyFiltrd.ids.push(booking.id)
            return
        }
        bookingAgenciesFiltered.push({ ...booking, ids: [booking.id] })
    })

    const bookingDrivers = data.result
        .filter(booking => booking.driver_id)
        .sort((a, b) => {
            const aName = a.driver?.name || ''
            const bName = b.driver?.name || ''
            if (aName < bName) {
                return -1
            }
            if (aName > bName) {
                return 1
            }
            return 0
        })
    // const bookingIndenpendecies = data.result
    //     .filter(booking => !booking.driver_id && !booking.agency_id)
    //     .sort((a, b) => {
    //         const aName = a.client_name || ''
    //         const bName = b.client_name || ''
    //         if (aName < bName) {
    //             return -1
    //         }
    //         if (aName > bName) {
    //             return 1
    //         }
    //         return 0
    //     })

    return (
        <Select
            onChange={ev => onBooking(ev.target.value)}
            value={bookingId}
            size="md"
            borderRadius="full"
            placeholder="Todos"
            bg="base-4"
            w={['full', 'auto', 'auto']}
        >
            <optgroup label="Agencias">
                {bookingAgenciesFiltered.map(booking => (
                    <option
                        key={booking.agency_guide_id}
                        value={booking.ids.join(',')}
                    >
                        {booking.agency?.name} - {booking.agency_guide?.name}
                    </option>
                ))}
                {bookingAgenciesFiltered.length === 0 && (
                    <option disabled>- Ninguno - </option>
                )}
            </optgroup>
            <optgroup label="Guías locales">
                {bookingDrivers.map(booking => (
                    <option key={booking.id} value={booking.id}>
                        {booking.driver?.name}
                    </option>
                ))}
                {bookingDrivers.length === 0 && (
                    <option disabled>- Ninguno - </option>
                )}
            </optgroup>
            {/* <optgroup label="Clientes independientes">
                {bookingIndenpendecies.map(booking => (
                    <option key={booking.id} value={booking.id}>
                        {booking.client_name}
                    </option>
                ))}
                {bookingIndenpendecies.length === 0 && (
                    <option disabled>- Ninguno - </option>
                )}
            </optgroup> */}
        </Select>
    )
}
